import { fetchResolverBasic } from 'actions/fetchResolver';
import { HpClientDebugFlags, hasFlag, log } from 'clientLogging';
import { getConfig } from 'config/configuration';
import { AuditType, AUDIT_DESCRIPTION } from 'interfaces/auditTypes';

interface SendAuditEventProps {
  activityId: AuditType;
  historyId?: number;
  policyDetailsId?: string;
  policyNumber?: string;
  activityDescription?: string;
}

export const sendAuditEvent = ({
  activityId,
  historyId,
  policyDetailsId,
  policyNumber,
  activityDescription
}: SendAuditEventProps): void => {
  const { websiteEndpoint } = getConfig();
  const url = `${websiteEndpoint}/api/customer/policy/audit-details`;
  const description = activityDescription || AUDIT_DESCRIPTION[activityId];
  const data = {
    activityDescription: description,
    artemisPolicyActivityTypeId: activityId,
    historyId,
    policyDetailsId,
    policyNumber
  };
  fetchResolverBasic({ url, method: 'POST', description: `Send audit event`, data })
    .then(() => {
      log
        .info()
        .enabledIf(hasFlag(HpClientDebugFlags.RestApi))
        .str('description', description)
        .number('activityId', activityId)
        .any('historyId', historyId)
        .any('policyDetailsId', policyDetailsId)
        .any('policyNumber', policyNumber)
        .msg('Audit event sent');
    })
    .catch((err) => {
      log
        .error()
        .err(err)
        .str('description', description)
        .number('activityId', activityId)
        .any('historyId', historyId)
        .any('policyDetailsId', policyDetailsId)
        .any('policyNumber', policyNumber)
        .msg('Failed to send audit event');
    });
};
